angular.module('Itao.IndicatorMap').factory('UtilityService', function (ScaleService, $sce) {
  'use strict';

  /**
   *
   * @param {Array} dataLayerTypes the dataLayerTypes to search in
   * @param {String} id the id to search for
   * @returns {DataLayerType | undefined}
   */
  function findDataLayerTypeByID(dataLayerTypes, id) {
    return dataLayerTypes.filter(function (dataLayerType) {
      return dataLayerType.id === id;
    }).shift();
  }

  /**
   * @param {Array} dataLayers the dataLayers to search in
   * @param {String} id the id to search for
   * @returns {DataLayer | undefined}
   */
  function findDataLayerByID(dataLayers, id) {
    return dataLayers.filter(function (dataLayer) {
      return dataLayer.uid === id;
    }).shift();
  }

  /**
   *
   * @param {Array} dataLayers the dataLayers to search in
   * @param {String} year the year to search for
   * @returns {DataLayer | undefined}
   */
  function findDataLayerByYear(dataLayers, year) {
    return dataLayers.filter(function (dataLayer) {
      return dataLayer.year === year;
    }).shift();
  }

  /**
   *
   * @param {Array} indicators the indicators to search in
   * @param {Array} ids the ids to search for
   * @returns {Array.<Indicator>}
   */
  function findIndicatorsByIDs(indicators, ids) {
    return indicators.filter(function (indicator) {
      return ids.indexOf(indicator.uid) > -1;
    });
  }

  /**
   *
   * @param {Array} colorSets
   * @param {String} uid
   * @returns {Array}
     */
  function findColorSetByUid(colorSets, uid) {
    return colorSets.filter(function (colorSet) {
      return colorSet.uid === uid;
    }).shift();
  }

  /**
   *
   * @param {Array} indicatorSets the indicatorSets to search in
   * @param {String} uid the uid to search for
   * @returns {IndicatorSet | undefined}
   */
  function findIndicatorSetByUid(indicatorSets, uid) {
    return indicatorSets.filter(function (indicatorSet) {
      return indicatorSet.uid === uid;
    }).shift();
  }

  /**
   * @param {Array} indicatorSets the indicatorsets to search in
   * @param {Array} indicators the indicators to search for
   * @returns {Array}
   */
  function findIndicatorSetsByIndicators(indicatorSets, indicators) {
    var newIndicatorSets = [];
    indicators.forEach(function (indicator) {
      if (indicator.type) {
        var type = findIndicatorSetByUid(indicatorSets, indicator.type);
        if (newIndicatorSets.indexOf(type) < 0) {
          newIndicatorSets.push(type);
        }
      }
    });
    return newIndicatorSets;
  }

  /**
   *
   * @param {Array} dataLayer all districts
   * @param {Indicator} indicator the indicatorID of the selected indicator
   * @param {Array} colorSet array of colors
   * @param {String} method
   * @param {integer} numberOfScales
   * @returns {Array}
   */
  function buildIndicatorScales(dataLayer, indicator, colorSet, method, numberOfScales) {
    var scales = [],
      values = [],
      selectedIndicatorID = indicator.uid,
      legend = 0;

    if(dataLayer.legend && dataLayer.legend[indicator.uid] && dataLayer.legend[indicator.uid]['map']) {
      legend = dataLayer.legend[indicator.uid]['map'];
      numberOfScales = legend.scales ? legend.scales.length : 0;
    } else if(indicator.defaultScale) {
      numberOfScales = indicator.defaultScale.length - 1;
    } else {
      numberOfScales = numberOfScales ? numberOfScales : 6;
    }

    method = method ? method : 'width';

    for(var districtUid in dataLayer.districts) {
      if(dataLayer.districts.hasOwnProperty(districtUid)
        && dataLayer.hasOwnProperty(districtUid)
        && dataLayer[districtUid].hasOwnProperty(selectedIndicatorID)
        && dataLayer[districtUid][selectedIndicatorID] !== null) {

        values.push(dataLayer[districtUid][selectedIndicatorID]);
      }
    }

    if(!values.length) return null;

    values.sort(sortNumber);
    if(legend) {
      return buildLegendScales(legend, colorSet, numberOfScales);
    }
    if(indicator.defaultScale) {
      return buildFixedScales(colorSet, indicator.defaultScale, numberOfScales);
    }
    if (method === 'width') {
      scales = buildScaleSameWidth(colorSet, numberOfScales, values);
    } else if (method === 'count') {
      scales = buildScaleSameClassCount(dataLayer, colorSet, numberOfScales, values);
    }

    return scales;
  }


  /**
   * @param {Object} colorSet
   * @param {Array} defaultScales
   * @param {integer} numberOfScales
   * @returns {Array}
   */
  function buildFixedScales(colorSet, defaultScales, numberOfScales) {
    var scales = [];
    for (var i = 0; i < numberOfScales; i++) {
      var from, to;
      var color = colorSet && colorSet.colors[i] ? colorSet.colors[i].color : '#cccccc';
      from = defaultScales[i];
      to = defaultScales[i+1];
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }

    return scales;
  }

  /**
   * @param {Object} legend
   * @param {Object} colorSet
   * @param {integer} numberOfScales
   * @returns {Array}
   */
  function buildLegendScales(legend, colorSet, numberOfScales) {
    var scales = [];
    for (var i = 0; i < numberOfScales; i++) {
      var from, to;
      var color = colorSet && colorSet.colors[i] ? colorSet.colors[i].color : '#cccccc';
      from = legend.scales[i].from;
      to = legend.scales[i].to;
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }

    return scales;
  }

  /**
   * @param {Object} colorSet
   * @param {integer} numberOfScales
   * @param {Array} values
   * @returns {Array}
   */
  function buildScaleSameWidth(colorSet, numberOfScales, values) {
    var maxValue = Math.max.apply(null, values);
    var minValue = Math.min.apply(null, values);

    // allways include 0 in legend
    if(maxValue < 0) {
      maxValue = 0;
    }
    if(minValue > 0) {
      minValue = 0;
    }

    var stepSize = Math.ceil(((maxValue - minValue)/ numberOfScales) * 100) / 100;
    var scales = [];
    for (var i = 0; i < numberOfScales; i++) {
      var from, to;
      var color = colorSet && colorSet.colors && colorSet.colors[i] ? colorSet.colors[i].color : '#cccccc';
      if(i === 0) {
        from = minValue;
      } else {
        from = scales[scales.length -1].to;
      }
      to = Math.ceil((minValue + (i+1) * stepSize) * 100)/100;
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }
    return scales;
  }

  /**
   * @param {DataLayer} dataLayer
   * @param {Object} colorSet
   * @param {integer} numberOfScales
   * @param {Array} values
   * @returns {Array}
   */
  function buildScaleSameClassCount(dataLayer, colorSet, numberOfScales, values) {
    numberOfScales = Math.min(values.length, numberOfScales);
    var numDataInClass = parseInt(values.length / numberOfScales);
    var to;
    var from;
    var scales = [];
    for (var i = 1; i <= numberOfScales; i++) {
      if (i === 1) {
        // first class
        from = Math.floor(values[0] * 100) / 100;
      } else {
        from = scales[scales.length - 1].to;
      }
      if(i === (+numberOfScales)) {
        to = Math.ceil(values[values.length - 1] * 100) / 100;
      } else if(numDataInClass === 1 && i === 1) {
        to = Math.ceil((from + (+values[1])) * 100 / 2) / 100;
      } else {
        to = Math.ceil(values[i * numDataInClass - 1] * 100) / 100;
      }

      var color = colorSet && colorSet.colors[i - 1] ? colorSet.colors[i - 1] : '#cccccc';
      scales.push(ScaleService.createScale(
        from,
        to,
        color,
        i
      ));
    }

    return scales;
  }

  function sortNumber(a, b) {
    return a - b;
  }

  function scaleForValue(scales, colorset, value) {
    return scales.map(function(scale, i){
      scale.color = colorset && colorset.colors[i] ? colorset.colors[i].color : '';
      return scale;
    }).filter(function(scale){
      return scale.from <= value && value < scale.to;
    })[0];
  }

  function iconSvg(scale) {
    if(!scale) return '';
    switch (scale.icon) {
      case 'icon-square':
        return $sce.trustAsHtml('<svg width="16px" height="16px" viewbox="0 0 16 16"><rect fill="' + scale.color + '" width="10" height="10" transform="translate(3 3)"></rect></svg>');
      case 'icon-diamond':
        return $sce.trustAsHtml('<svg width="16px" height="16px" viewbox="0 0 16 16"><rect fill="' + scale.color + '" width="10" height="10" transform="rotate(45 5 5) translate(4)"></rect></svg>');
      case 'icon-circle':
        return $sce.trustAsHtml('<svg width="16px" height="16px" viewbox="0 0 16 16"><circle fill="' + scale.color + '" r="7" transform="translate(8 8)"></circle></svg>');
      case 'icon-not-available':
        // return $sce.trustAsHtml('<span class="svg-not-available"></span>');
        return $sce.trustAsHtml('<svg width="16" height="16" viewBox="0 0 16 16"><circle fill="#ffffff" r="7" stroke="#74777a" stroke-width="0.75px" transform="translate(8 8)"/><path fill="#74777a" d="M5.5,8.7l0.038-1H10l-0.038,1H5.01Z"/></svg>');
      case 'icon-info':
        // return $sce.trustAsHtml('<span class="svg-info"></span>');
        return $sce.trustAsHtml('<svg width="16" height="16" viewBox="0 0 16 16"><circle fill="#ffffff" r="7" stroke="#74777a" stroke-width="0.75px" transform="translate(8 8)"/><path fill="#74777a" d="M7.2,7.5l1,0.038V12l-1-.038V7.014Z"/><circle class="cls-3" cx="7.7" cy="5.5" r="0.75" fill="#74777a"/></svg>');
      default: return $sce.trustAsHtml('<svg width="15px" height="15px" viewbox="0 0 16 16"><circle fill="#ffffff" r="7" stroke="#74777a" stroke-width="0.75px" transform="translate(8 8)"></circle></svg>');
    }
  }

  return {
    findDataLayerTypeByID: findDataLayerTypeByID,
    findDataLayerByID: findDataLayerByID,
    findDataLayerByYear: findDataLayerByYear,
    findIndicatorsByIDs: findIndicatorsByIDs,
    findIndicatorSetByUid: findIndicatorSetByUid,
    findColorSetByUid: findColorSetByUid,
    buildIndicatorScales: buildIndicatorScales,
    scaleForValue: scaleForValue,
    iconSvg: iconSvg,
    findIndicatorSetsByIndicators: findIndicatorSetsByIndicators
  };
});
